module.exports = __webpack_public_path__ + "VAGRoundedStd-Light.70caca0c72fe798c01a9.ttf";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Light.ttf
// module id = ../../../../../src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Light.ttf
// module chunks = styles